import {
  Component,
  Inject,
  Injector,
  forwardRef,
  ElementRef,
  OnInit,
  Optional,
  NgModule,
  ViewEncapsulation
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { Validators } from '@angular/forms';
import { ValidatorFn } from '@angular/forms/src/directives/validators';

import { OSharedModule } from '../../../shared';
import { OFormComponent } from '../../form/o-form.component';
import { InputConverter } from '../../../decorators';
import {
  OIntegerInputModule,
  OIntegerInputComponent,
  DEFAULT_INPUTS_O_INTEGER_INPUT,
  DEFAULT_OUTPUTS_O_INTEGER_INPUT
} from '../integer-input/o-integer-input.component';

import {
  ORealPipe,
  IRealPipeArgument
} from '../../../pipes';

export const DEFAULT_INPUTS_O_REAL_INPUT = [
  ...DEFAULT_INPUTS_O_INTEGER_INPUT,
  'minDecimalDigits: min-decimal-digits',
  'maxDecimalDigits: max-decimal-digits',
  'decimalSeparator : decimal-separator',
  'decimalDigits : decimal-digits'
];

export const DEFAULT_OUTPUTS_O_REAL_INPUT = [
  ...DEFAULT_OUTPUTS_O_INTEGER_INPUT
];


export class ORealInputComponent extends OIntegerInputComponent implements OnInit {

  public static DEFAULT_INPUTS_O_REAL_INPUT = DEFAULT_INPUTS_O_REAL_INPUT;
  public static DEFAULT_OUTPUTS_O_REAL_INPUT = DEFAULT_OUTPUTS_O_REAL_INPUT;

  @InputConverter()
  minDecimalDigits: number = 2;//TODO pending

  @InputConverter()
  maxDecimalDigits: number = 2;//TODO pending

  @InputConverter()
  step: number;

  @InputConverter()
  decimalDigits: number;

  @InputConverter()
  grouping: boolean = true;

  protected decimalSeparator: string;
  protected pipeArguments: IRealPipeArgument;

  constructor(
      form: OFormComponent,
    elRef: ElementRef,
    injector: Injector) {
    super(form, elRef, injector);
  }

  setComponentPipe() {
    this.componentPipe = new ORealPipe(this.injector);
  }

  ngOnInit() {
    if (this.step === undefined) {
      this.step = 1 / Math.pow(10, this.decimalDigits);
    }

    super.ngOnInit();
    this.pipeArguments.decimalSeparator = this.decimalSeparator;
    this.pipeArguments.decimalDigits = this.decimalDigits;

    if (this.decimalDigits === undefined) {
      this.decimalDigits = 2;
    }
  }

  resolveValidators(): ValidatorFn[] {
    let validators: ValidatorFn[] = super.resolveValidators();
    // Inject pattern validator for formatting value
    let pattern = '[-+]?[0-9]+(\.[0-9]{' + this.minDecimalDigits + ',' + this.maxDecimalDigits + '})?';
    validators.push(Validators.pattern(pattern));
    return validators;
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-real-input',
  template: `
    <div [formGroup]="getFormGroup()" [mdTooltip]="tooltip" [mdTooltipPosition]="tooltipPosition" [mdTooltipShowDelay]="tooltipShowDelay">
        <md-form-field #innerInputContainer fxFlexFill >
            <input mdInput type="number" [attr.id]="getAttribute()" [id]="getAttribute()" [formControlName]="getAttribute()"
                [placeholder]="placeHolder" [ngModel]="getValue()" (ngModelChange)="innerOnChange($event)" (focus)="innerOnFocus($event)"
                (blur)="innerOnBlur($event)" [readonly]="isReadOnly" [min]="min" [max]="max" [step]="step">
            <md-error *ngIf="hasError('required')">{{ 'FORM_VALIDATION.REQUIRED' | oTranslate }}</md-error>
            <md-error *ngIf="hasError('min')">{{ 'FORM_VALIDATION.MIN_VALUE' | oTranslate }}: {{ getErrorValue('min', 'requiredMin') }}</md-error>
            <md-error *ngIf="hasError('max')">{{ 'FORM_VALIDATION.MAX_VALUE' | oTranslate }}: {{ getErrorValue('max', 'requiredMax') }}</md-error>
            <md-error *ngIf="hasError('pattern')">{{ 'FORM_VALIDATION.FORMAT' | oTranslate }}</md-error>
        </md-form-field>
    </div>
  `,
  styles: [`

  `],
  inputs: [
    ...DEFAULT_INPUTS_O_REAL_INPUT
  ],
  outputs: [
    ...DEFAULT_OUTPUTS_O_REAL_INPUT
  ],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: OFormComponent, decorators: [{ type: Optional }, { type: Inject, args: [forwardRef(() => OFormComponent), ] }, ]},
{type: ElementRef, },
{type: Injector, },
];
}


export class ORealInputModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [ORealInputComponent],
  imports: [OSharedModule, CommonModule, OIntegerInputModule],
  exports: [ORealInputComponent, OIntegerInputModule],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
